<template>
    <div class="light-box" v-if="show">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "LightBox",
        props: {
            show: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>
.light-box {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: #000;
    opacity: .5;
    z-index: 2000;
}
</style>